import { render, staticRenderFns } from "./DashboardNotifications.vue?vue&type=template&id=07ce93e4&scoped=true&"
import script from "./DashboardNotifications.vue?vue&type=script&lang=js&"
export * from "./DashboardNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNotifications.vue?vue&type=style&index=0&id=07ce93e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ce93e4",
  null
  
)

export default component.exports